import { UpgradeData } from '../../game/data.type';

export const UpgradeInfoTable: React.FC<{ upgrades: UpgradeData[] }> = ({ upgrades }) => {
  return (
    <table className="tooltip-table">
      <tbody>
        {upgrades.map((upgrade) => {
          return (
            <tr key={upgrade.description}>
              <td>
                <img src={upgrade.icon} style={{ width: '1.2rem' }} />
              </td>
              <td>{upgrade.description}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
